var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgModalNone = function SvgModalNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "modalNone_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.24,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFA",
    stopOpacity: 0.416,
    offset: "38.127%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF0",
    stopOpacity: 0.846,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "4.019%",
    y2: "50%",
    id: "modalNone_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBDF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABDC0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-267.246%",
    y1: "144.689%",
    x2: "153.659%",
    y2: "-154.312%",
    id: "modalNone_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2E5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "135.447%",
    y1: "54.862%",
    x2: "-16.096%",
    y2: "40.311%",
    id: "modalNone_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CBCE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.105 57.276C219.291 47.73 204.471 0 101.711 0 27.54 0-6.503 39.068 1.023 58.867l213.082-1.59Z",
    id: "modalNone_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h215v200H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#modalNone_svg__b)",
    fillRule: "nonzero",
    xlinkHref: "#modalNone_svg__a",
    transform: "translate(0 128.158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.703 142.444c28.717 0 51.997-1.718 51.997-3.837s-23.28-3.837-51.997-3.837-51.203-5.233-51.203 0 22.486 7.674 51.203 7.674Z",
    fill: "url(#modalNone_svg__c)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.217 72h26.952a5.434 5.434 0 0 1 4.741 2.779l1.187 2.119a7.471 7.471 0 0 0 6.519 3.82h29.209a4.075 4.075 0 0 1 4.075 4.076V134l-78.117-.969V77.434c0-3.001 2.433-5.434 5.434-5.434Z",
    fill: "url(#modalNone_svg__d)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.831 85.238 6.328-5.833a7.795 7.795 0 0 1 10.315-.223l1.722 1.456a5.113 5.113 0 0 0 6.857-.232l14.195-13.74h0",
    stroke: "#D9DBDF",
    strokeWidth: 6.818,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.156 61.5-3.104 16.17a1.974 1.974 0 0 1-3.25 1.104L135.772 67.2a1.974 1.974 0 0 1 .77-3.374l16.136-4.596a1.974 1.974 0 0 1 2.479 2.27Z",
    fill: "#D9DBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.322 87.333h66.828a5.434 5.434 0 0 1 5.387 6.147l-5.252 39.705a4.754 4.754 0 0 1-4.733 4.131l-69.116-.285a4.754 4.754 0 0 1-4.697-5.35l4.844-38.406a6.792 6.792 0 0 1 6.739-5.942Z",
    fill: "url(#modalNone_svg__e)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.027 96.286h18.262a2.717 2.717 0 0 1 2.691 3.087l-.034.246a3.86 3.86 0 0 1-3.823 3.333H80.782a2.717 2.717 0 0 1-2.684-3.138l.03-.195a3.946 3.946 0 0 1 3.899-3.333Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.418 108.857h31.257a2.717 2.717 0 0 1 2.658 3.276l-.032.153a4.075 4.075 0 0 1-3.988 3.238h-31.28a2.702 2.702 0 0 1-2.628-3.334l.05-.209a4.075 4.075 0 0 1 3.963-3.124Z",
    fill: "#FFF",
    opacity: 0.869
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.81 121.429h47.93a2.586 2.586 0 0 1 2.476 3.333l-.132.435a4.075 4.075 0 0 1-3.901 2.898H81.13a2.514 2.514 0 0 1-2.377-3.333l.203-.587a4.075 4.075 0 0 1 3.852-2.746Z",
    fill: "#FFF",
    opacity: 0.772
  }))));
};
export default SvgModalNone;